module.exports = __webpack_public_path__ + "static/media/header-bg-3.b7f60bc7.jpg";